import * as R from 'ramda'
import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import {
  GetHasParticipantsCategoriesBeenUpdated,
  GetParticipantsCategoriesQtyList,
  HasSameParticipantsCategoriesNumberAsPreviously,
  HasSameParticipantsTotalNumberAsPreviously
} from './types/getHasParticipantsCategoriesBeenUpdated.types'
import {
  getParticipantsNumber,
  getParticipantsWithBirthdateNumber
} from '.'

const hasSameParticipantsTotalNumberAsPreviously: HasSameParticipantsTotalNumberAsPreviously = (
  previous,
  current
) => (
  +previous === +current
)

const hasSameParticipantsCategoriesNumberAsPreviously: HasSameParticipantsCategoriesNumberAsPreviously = (
  previous,
  current
) => (
  R.equals(previous, current)
)

const getParticipantsCategoriesQtyList: GetParticipantsCategoriesQtyList = (
  participants
) => (
  PARTICIPANTS_CATEGORIES.map(category => participants[category].number)
)

export const getHasParticipantsCategoriesBeenUpdated: GetHasParticipantsCategoriesBeenUpdated = (
  prevParticipants,
  participants
) => {
  const participantsCategoriesQtyList = getParticipantsCategoriesQtyList(participants)
  const prevParticipantsCategoriesQtyList = getParticipantsCategoriesQtyList(prevParticipants)
  const totalParticipants = (getParticipantsNumber(participants) - getParticipantsWithBirthdateNumber(participants))
  const totalPrevParticipants = (getParticipantsNumber(prevParticipants) - getParticipantsWithBirthdateNumber(prevParticipants))

  return Boolean(
    !hasSameParticipantsTotalNumberAsPreviously(totalPrevParticipants, totalParticipants) ||
    !hasSameParticipantsCategoriesNumberAsPreviously(participantsCategoriesQtyList, prevParticipantsCategoriesQtyList)
  )
}
